module.exports = __webpack_public_path__ + "img/6523913.ee56cb18.png";